import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Plus from '../img/plus';
import NewListInput from './NewListInput';
import { clickCreate } from '../actions';
import * as selectors from '../selectors';

export default ({ artId }) => {
  const dispatch = useDispatch();
  const inputVisible = useSelector(selectors.inputVisible);
  const inputError = useSelector(selectors.inputError);
  return (
    <>
      <div
        class="fav__create"
        onClick={e => {
          e.preventDefault();
          dispatch(clickCreate());
        }}
      >
        <Plus />
        {!inputVisible && <span>Luo uusi suosikkilista</span>}
        {inputVisible && <NewListInput />}
      </div>
      {inputError && (
        <div className="fav__input-error">
          Tapahtui virhe. Yritä myöhemmin uudelleen.
        </div>
      )}
    </>
  );
};
